export function formatAmount(amount: number, currency: string) {
  if (Number.isInteger(Number(amount))) return `${new Intl.NumberFormat('fr-FR').format(amount)} ${currency}`;
  else return `${amount} ${currency}`;
}
